export const FILE_UPLOAD_VARIANT = {
  BROWSE: "BROWSE",
  DRAG_DROP_BROWSE: "DRAG_DROP_BROWSE",
};
